import React from 'react';
import { motion } from 'framer-motion';
import { LockIcon, ZapIcon } from 'lucide-react';
interface CtaButtonProps {
  label?: string;
  showCuotas?: boolean;
  showPaymentSeal?: boolean;
  checkout?: boolean;
}
export function CtaButton({
  label = 'SÍ, QUIERO LAS 250 RECETAS Y LOS 5 BONOS',
  showCuotas = true,
  showPaymentSeal = false,
  checkout = false
}: CtaButtonProps) {
  const destination = checkout ? 'https://megapackairfryargentina.impultienda.ar/' : '#oferta-principal';
  const ariaLabel = checkout ? 'Ir al checkout seguro del MegaPack' : 'Ir a la oferta principal del MegaPack';
  return <div className="w-full max-w-xl mx-auto" data-id="element-41" data-mp="109238yhomvxf">
      {showCuotas && <div className="mb-3 flex flex-col items-center gap-1" data-id="element-42" data-mp="vbk58357e147">
          <span className="inline-flex items-center gap-2 rounded-full bg-green-100 px-4 py-1.5 text-sm font-bold text-green-800" data-id="element-43" data-mp="vddc9jjqancq">
            <ZapIcon className="h-4 w-4" data-id="element-44" data-mp="159q389nw2n3s" />
            En hasta 3 cuotas • Acceso inmediato
          </span>
        </div>}
      <motion.a href={destination} whileHover={{
      scale: 1.02
    }} whileTap={{
      scale: 0.98
    }} animate={{
      scale: [1, 1.015, 1]
    }} transition={{
      scale: {
        duration: 1.8,
        repeat: Infinity,
        ease: 'easeInOut'
      }
    }} aria-label={ariaLabel} className="group flex w-full flex-col items-center justify-center rounded-2xl bg-green-600 px-6 py-5 text-center shadow-[0_10px_30px_-6px_rgba(22,163,74,0.6)] transition-colors hover:bg-green-700" data-id="element-45" data-mp="35xxtsu4w8vuv">
        <span className="text-lg font-extrabold uppercase leading-tight tracking-tight text-white sm:text-2xl" data-id="element-46" data-mp="3swtzpicgv7c2">
          {label}
        </span>
        <span className="mt-1 text-xl font-black text-yellow-300 sm:text-2xl" data-id="element-47" data-mp="1jpsw8ehecrp">
          POR $14.900
        </span>
      </motion.a>
      {showPaymentSeal && <div className="mt-4 flex justify-center" data-id="element-48" data-mp="bhwxrsvhx4dc">
          <img src="https://cdn.magicpatterns.com/uploads/pWoCPekSYcazdCDvugwUjT/pasted-image.jpg" alt="Mercado Pago, tarjetas y compra 100% segura con SSL" className="h-32 w-auto max-w-full rounded-lg bg-white object-contain p-1" data-id="element-49" data-mp="bf11e8zaqnr0" />
        </div>}
      <div className="mt-3 flex flex-wrap items-center justify-center gap-x-4 gap-y-1 text-xs font-medium text-neutral-500" data-id="element-50" data-mp="3hz5jnynek6sj">
        <span className="flex items-center gap-1" data-id="element-51" data-mp="io01k57ufdd">
          <ZapIcon className="h-3.5 w-3.5 text-green-600" data-id="element-52" data-mp="3rwtrnqa0rasn" /> Acceso inmediato
        </span>
        <span className="flex items-center gap-1" data-id="element-53" data-mp="9ikj968u6m11">
          <LockIcon className="h-3.5 w-3.5 text-green-600" data-id="element-54" data-mp="9h9dx1zqt67t" /> Pago seguro
        </span>
        <span className="flex items-center gap-1" data-id="element-55" data-mp="4ig17bsa5j8p">🛡️ Garantía 7 días</span>
      </div>
    </div>;
}